export const adminEnvironment = {
  auth0: {
    domain: 'admin-media-hub.us.auth0.com',
    clientId: 'Geo2qVAJm607GZbKqEiik4bS2ZhHJR1T',
    audience: 'https://admin.api.media-hub.videomagic.ai',
  },
}
